<template>
  <div class="container">
    <div class="privacy__content__img">
      <img src="../../public/assets/img/banner/privacy-policy.jpg" alt="" />
    </div>
    <div class="privacy__content__text">
      <h2>Privacy Policy</h2>
      <h4>
        What is a privacy policy?
      </h4>
      <p>
        A privacy policy is a legal document where you disclose what data you
        collect from users, how you manage the collected data and how you use
        that data. The important objective of a privacy policy is to inform
        users how you collect, use and manage the collected.
      </p>

      <h4>Is the privacy policy generator free to use?</h4>
      <p>
        The Privacy Policy Generator (privacypolicygenerator.info) is a free
        generator of privacy policies for websites, apps & Facebook pages/app.
        You can use our free generator to create the privacy policy for your
        business.
      </p>

      <h4>Why is a privacy policy important?</h4>
      <p>
        The most important thing to remember is that a privacy policy is
        required by law if you collect data from users, either directly or
        indirectly. For example, if you have a contact form on your website you
        need a privacy policy. But you will also need a privacy policy if you
        use analytics tools such as Google Analytics.
      </p>

      <h4>Where do I put my privacy policy?</h4>
      <p>
        Usually, you can find privacy policies in the footer of a website. We
        recommend that you place your privacy policy in easy to find locations
        on your website.
      </p>

      <h4>What should the privacy policy include?</h4>
      <p>
        A standard privacy policy should include: what data you collect from
        visitors, how you collect it, why you are collecting the data, how you
        are using the data.
      </p>

      <h4>Can I copy someone else's privacy policy?</h4>
      <p>
        We do not recommend copying someone else's privacy policy. First of all,
        privacy policies are copyright-protected legal documents. But most
        importantly, a privacy policy must be generated based on the exact data
        you collect. Our privacy policy generator can help you with this.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.privacy__content__img img {
  width: 100%;
  height: 30rem;
}
.privacy__content__text {
  text-align: center;
  padding: 50px;
}
.privacy__content__text h2 {
  font-weight: 700;
  margin-bottom: 30px;
}
</style>
